import React, { useState, useContext } from 'react';
import QuestionIcon from '@atlaskit/icon/glyph/question';
import Button from '@atlaskit/button';
import InlineDialog from '@atlaskit/inline-dialog';
import { GlobalContext } from '../common/GlobalContext';

export const CepHelpDialog = ({ helpContent, helpUri }: { helpContent?: React.ReactNode; helpUri?: string }) => {
  const [helpDialogIsOpen, setHelpDialogIsOpen] = useState<boolean>(false);
  const { t, globals, routerOpen } = useContext(GlobalContext);
  const toggleHelpDialog = () => setHelpDialogIsOpen((prevHelpDialogIsOpen: boolean) => !prevHelpDialogIsOpen);

  const helpUriButtonView = helpUri ? (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div style={{ marginRight: '20px' }}>{t('global.help.youCanGetMoreInfo')}</div>
      <div>
        <Button target="_blank" appearance="primary" onClick={() => routerOpen(globals.helpUrl(helpUri))}>
          {t('global.help.documentationButton')}
        </Button>
      </div>
    </div>
  ) : null;
  const helpContentView = (
    <>
      {helpContent && <div style={{ marginBottom: '10px' }}>{helpContent}</div>}
      {helpUriButtonView}
    </>
  );
  return (
    <InlineDialog onClose={toggleHelpDialog} content={helpContentView} isOpen={helpDialogIsOpen} placement="bottom-end">
      <Button appearance="subtle" spacing="none" iconBefore={<QuestionIcon label="open icon" />} isSelected={helpDialogIsOpen} onClick={toggleHelpDialog} />
    </InlineDialog>
  );
};
